import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import i18n from '../i18n';
import { retrieveStorageById, patchStorage } from '../helpers/storeService';
import { useParams } from 'react-router';
import useRouting from '../hooks/useRouting';
import { ChatContext } from '../contexts/ChatContext';
import FlowChatBox from '../components/FlowChatBox';
import { getNestedObject } from '../helpers/objectService';

const FlowCarReplacementVehicle = () => {
  const { id, affinity, insuranceType, currentVehicle } = useParams();
  const { renderNextRoute } = useRouting();
  const { data } = retrieveStorageById(id, affinity, insuranceType) || {};
  const { addQuestion, addAnswer } = useContext(ChatContext);
  const [defaultValues, setDefaultValues] = useState({});
  const [error, setError] = useState();

  useEffect(() => {
    const question = {
      message: i18n.t(
        'Do you wish to <span>stay mobile</span> during a technical or mechanical <span>breakdown?</span>'
      ),
      slug: 'replacement_vehicle',
    };
    addQuestion(question);
    loadDefaultValues();
  }, []);

  const loadDefaultValues = async () => {
    const defaultValuesTemp = {
      replacement_vehicle: getNestedObject(data, [
        'cars',
        [currentVehicle],
        'replacement_vehicle',
      ]),
    };
    setDefaultValues(defaultValuesTemp);
  };

  const submitHandler = () => {
    if (defaultValues?.replacement_vehicle == null) {
      setError('Please answer the question above');
      return;
    } else {
      setError();
    }
    let car_information = {
      replacement_vehicle: defaultValues.replacement_vehicle,
    };
    patchStorage({
      payload: car_information,
      path: ['cars', [currentVehicle]],
      id,
      affinity,
      insuranceType,
    });

    const answer = {
      message: i18n.t(defaultValues.replacement_vehicle ? `Yes` : 'No'),
      slug: 'replacement_vehicle',
    };

    addAnswer(answer);

    renderNextRoute(1, { vehicle: currentVehicle });
  };

  return (
    <Container>
      <FlowChatBox />
      <RightContainer>
        <AddressToInsureQ>
          <StyledButton
            active={defaultValues.replacement_vehicle === true}
            onClick={() => {
              defaultValues.replacement_vehicle = true;
              submitHandler();
            }}
          >
            {i18n.t('Yes')}
          </StyledButton>
          <StyledButton
            active={defaultValues?.replacement_vehicle === false}
            onClick={() => {
              defaultValues.replacement_vehicle = false;
              submitHandler();
            }}
          >
            {i18n.t('No')}
          </StyledButton>
        </AddressToInsureQ>
        <Error>{error}</Error>
      </RightContainer>
    </Container>
  );
};

const Error = styled.div`
  justify-content: left;
  font-size: 1.4rem;
  color: #f74040;
`;

const AddressToInsureQ = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 45% 45%;
  width: 100%;
  justify-content: center;
`;

const StyledButton = styled.button`
  background-color: ${({ active, theme }) =>
    active ? theme.brand.primary : '#ffffff'};
  border: ${({ active, theme }) =>
    active ? 'none' : `2px solid ${theme.brand.primary}`};
  border-radius: 5px;
  color: ${({ active, theme }) => (active ? '#ffffff' : theme.brand.primary)};
  cursor: pointer;
  font-weight: bold;
  font-size: 1.4rem;
  height: 4rem;
  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.brand.light};
    color: white;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  width: 100%;
  overflow: hidden;
`;

const RightContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 2rem;
`;

export default FlowCarReplacementVehicle;
